function approvalFormDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/approval-form/approval-form-dialog.html?$$REVISION$$'
  }
}

export { approvalFormDialogDirective }
